import { useReactiveVar } from '@apollo/client'
import { useSelectedOrganizationIdVar } from '../models/SelectedOrganization'

export const useSelectedOrganizationIdFn = (): string => {
  const id = useReactiveVar(useSelectedOrganizationIdVar)
  return id ?? ''
}
